var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{attrs:{"fluid":""}},[_c('v-row',[_c('sarala-table',{ref:"table",attrs:{"model":_vm.model,"createRoute":{ name: 'settings.create' },"resourceName":_vm.$tc('resources.settings.name', 1)},scopedSlots:_vm._u([{key:"action",fn:function(ref){
var item = ref.item;
return [_c('edit-btn',{attrs:{"to":{
                        name: 'settings.edit',
                        params: { id: item.id },
                    }}}),_c('delete-btn',{on:{"click":function($event){return _vm.deleteItem(item)}}})]}}])})],1),_c('confirm-delete',{ref:"confirmDelete"})],1)}
var staticRenderFns = []

export { render, staticRenderFns }